import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import { colorify } from "lottie-colorify";

/**
 * Props used by the <Lottie /> component
 * @typedef {Object} LottieProps
 * @prop {String} animation
 * @prop {Number} width
 * @prop {Number} height
 * @prop {String[]} [colors]
 */

/**
 * <Lottie />
 * @param {LottieProps} props
 */
const Lottie = ({ animation, width, height, colors, additionalDivProps = {}, ...rest }) => {
  const element = useRef(null);
  const lottieInstance = useRef();

  const animationData = colors ? colorify(colors, animation) : animation;

  useEffect(() => {
    if (element.current && !lottieInstance.current) {
      lottieInstance.current = lottie.loadAnimation({
        animationData,
        container: element.current,
        ...rest,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animationData]);

  return <div style={{ width, height }} ref={element} {...additionalDivProps}></div>;
};

export default Lottie;
